import { cn } from '@shared/components/shadcn';
import { NavigationMenuItem } from './components/NavigationMenuItem/NavigationMenuItem';
import type { NavigationMenuProps } from './types';

function NavigationMenu({ variant = 'default', items, className, ...props }: NavigationMenuProps) {
  const COMMON_WRAPPER_CLASSES = 'flex items-center justify-center flex-col';
  const styles = {
    variants: {
      default: {
        wrapper: cn(COMMON_WRAPPER_CLASSES, className),
      },
      secondary: {
        wrapper: cn(COMMON_WRAPPER_CLASSES, 'rounded-lg border border-border', className),
      },
    },
  };

  const classes = styles.variants[variant];

  function Divider() {
    return <hr className="h-px border-t-border w-full" />;
  }

  return (
    <div className={classes.wrapper} data-track-container="Navigation List" data-testid="navigation-list" {...props}>
      {items.map((item, index) => (
        <div key={index} className="w-full">
          <NavigationMenuItem
            {...item}
            className={cn(
              variant === 'secondary' && 'px-4',
              variant === 'secondary' && index === 0 && 'rounded-t-lg',
              variant === 'secondary' && index === items.length - 1 && 'rounded-b-lg'
            )}
          />
          {variant === 'secondary' ? index !== items.length - 1 && <Divider /> : <Divider />}
        </div>
      ))}
    </div>
  );
}

export { NavigationMenu };
